import type { ActivatedRouteSnapshot } from '@angular/router';

export interface FaqRouteParams {
  position: string | undefined;
  section: string | undefined;
}

export const getFaqRouteParams = (route: ActivatedRouteSnapshot): FaqRouteParams => ({
  position: route.paramMap.get('position') ?? route.url.at(1)?.path,
  section: route.paramMap.get('section') ?? route.url.at(0)?.path,
});
